import { Dispatch } from 'redux';
import { AssetStateRecord } from '../../Interfaces/Assets/AssetState';
import { CategoryCountRequest } from '../../Interfaces/Assets/CategoryCountRequest';
import { CommandInfo } from '../../Interfaces/Commands/CommandInfo';
import { TicketRecord } from '../../Interfaces/Tickets/TicketRecord';
import { actionCreators } from './AssetStatesState';
import { TrendsGridFilter } from '../../Interfaces/Devices/Trends/TrendsGridFilter';
import { FirmwareInfo, MultipleFirmwareRecords } from '../../Interfaces/Devices/FirmwareInfo';

export const resetState = async (dispatch: Dispatch<any>) => {
  return dispatch(actionCreators.resetState());
};

export const fetchAssetStatePropertiesByNode = async (
  dispatch: Dispatch<any>,
  nodeID: number
) => {
  return dispatch(actionCreators.fetchAssetStatePropertiesByNode(nodeID));
};

export const fetchAssetStatusesByQuery = async (dispatch: Dispatch<any>) => {
  return dispatch(actionCreators.fetchAssetStatusesByQuery());
};

export const getCurrentIssueCategories = async (dispatch: Dispatch<any>) => {
  return dispatch(actionCreators.getCurrentIssueCategories());
};

export const getCurrentIssuesForCategory = async (
  dispatch: Dispatch<any>,
  categoryCountRequest: CategoryCountRequest
) => {
  return dispatch(
    actionCreators.getCurrentIssuesForCategory(categoryCountRequest)
  );
};

export const sendDeviceCommand = async (
  dispatch: Dispatch<any>,
  record: AssetStateRecord,
  commandInfo: CommandInfo
) => {
  return dispatch(
    actionCreators.sendDeviceCommand(record.NodeInfo.NodeID, commandInfo)
  );
};

export const sendDeviceCommandFromTicket = async (
  dispatch: Dispatch<any>,
  ticket: TicketRecord,
  commandInfo: CommandInfo
) => {
  return dispatch(actionCreators.sendDeviceCommand(ticket.NodeID, commandInfo));
};

export const resetAssetStatusesFetchError = async (dispatch: any) => {
  return dispatch(actionCreators.resetAssetStatusesFetchError());
};

export const clearCommandNotificationSuccessMessage = async (
  dispatch: any,
  commandInfo: CommandInfo | undefined
) => {
  return dispatch(
    actionCreators.clearCommandNotificationSuccessMessage(commandInfo)
  );
};

export const getAssetStateNameCount = async (
  dispatch: Dispatch<any>,
  name: string
) => {
  return dispatch(actionCreators.getAssetStateNameCount(name));
};

export const getNodeStatusCounts = async (dispatch: Dispatch<any>) => {
  return dispatch(actionCreators.getNodeStatusCounts());
};

export const getTopDeviceIssuesCountBySite = async (
  dispatch: Dispatch<any>,
  rowsCount: number
) => {
  return dispatch(actionCreators.getTopDeviceIssuesCountBySite(rowsCount));
};

export const getTopLanesDownCountBySite = async (
  dispatch: Dispatch<any>,
  rowsCount: number
) => {
  return dispatch(actionCreators.getTopLanesDownCountBySite(rowsCount));
};

export const getTopAssetStateCountsByName = async (
  dispatch: Dispatch<any>,
  name: string,
  rowsCount: number
) => {
  return dispatch(actionCreators.getTopAssetStateCountsByName(name, rowsCount));
};

export const getCurrentIssueCountsByDateRange = async (
  dispatch: Dispatch<any>
) => {
  return dispatch(actionCreators.getCurrentIssueCountsByDateRange());
};

export const getCurrentIssueCountsByDate = async (
  dispatch: Dispatch<any>,
  trendsGridFilter: TrendsGridFilter
) => {
  return dispatch(actionCreators.getCurrentIssueCountsByDate(trendsGridFilter));
};

export const getFirmwareInfo = async (dispatch: Dispatch<any>) => {
  return dispatch(actionCreators.getFirmwareInfo());
};

export const addNewFirmwareInfo = async (
  dispatch: Dispatch<any>,
  firmwareInfo: MultipleFirmwareRecords
) => {
  return dispatch(actionCreators.addNewFirmwareInfo(firmwareInfo));
};

export const updateFirmwareFile = async (
  dispatch: Dispatch<any>,
  formData: FormData
) => {
  return dispatch(actionCreators.updateFirmwareFile(formData));
};

export const removeFirmwareInfo = async (
  dispatch: Dispatch<any>,
  firmwareInfo: FirmwareInfo
) => {
  return dispatch(actionCreators.removeFirmwareInfo(firmwareInfo));
};

export const getCurrentIssuePropertiesCSV = async (dispatch: Dispatch<any>) => {
  return dispatch(actionCreators.getCurrentIssuePropertiesCSV());
};

export const calculateChecksum = async(dispatch: Dispatch<any>, formData: FormData) => {
  return dispatch(actionCreators.calculateChecksum(formData));
}

export const uploadFirmwareFile = async(dispatch: Dispatch<any>, formData: FormData | undefined) => {
  return dispatch(actionCreators.uploadFirmwareFile(formData));
}

export const resetSuccessMessage = async (dispatch: Dispatch<any>) => {
  return dispatch(actionCreators.resetSuccessMessage());
};

export const resetUpdateMessage = async (dispatch: Dispatch<any>) => {
  return dispatch(actionCreators.resetUpdateMessage());
};

export const resetDeleteMessage = async (dispatch: Dispatch<any>) => {
  return dispatch(actionCreators.resetDeleteMessage());
};

export const clearConfirmationMessage = async (dispatch: Dispatch<any>) => {
  return dispatch(actionCreators.clearConfirmationMessage());
};

export const clearChecksum = async (dispatch: Dispatch<any>) => {
  return dispatch(actionCreators.clearChecksum());
}
